export default __webpack_public_path__ + "static/media/fNeutral11.36c84bf2.png";